import React, { useState } from 'react';
import { signIn, signOut, getCurrentUser } from 'aws-amplify/auth';

function AdminLogin({ onLogin, onLogout, isAdmin }) {
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [needsNewPassword, setNeedsNewPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await signIn({ username: email, password });
      if (result.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        setNeedsNewPassword(true);
      } else {
        const user = await getCurrentUser();
        onLogin(user);
        setShowLogin(false);
        setEmail('');
        setPassword('');
      }
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { confirmSignIn } = await import('aws-amplify/auth');
      await confirmSignIn({ challengeResponse: newPassword });
      const user = await getCurrentUser();
      onLogin(user);
      setShowLogin(false);
      setNeedsNewPassword(false);
    } catch (err) {
      setError(err.message || 'Failed to set new password');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await signOut();
    onLogout();
  };

  if (isAdmin) {
    return (
      <button className="logout-btn" onClick={handleLogout}>Logout</button>
    );
  }

  if (!showLogin) {
    return (
      <button className="admin-toggle" onClick={() => setShowLogin(true)}>Admin</button>
    );
  }

  if (needsNewPassword) {
    return (
      <form className="admin-login" onSubmit={handleNewPassword}>
        <input
          type="password"
          placeholder="Set new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoFocus
          required
        />
        {error && <span style={{ color: 'var(--crimson-bright)', fontSize: '0.75rem' }}>{error}</span>}
        <button type="submit" disabled={loading}>{loading ? '...' : 'Set Password'}</button>
        <button type="button" onClick={() => { setShowLogin(false); setNeedsNewPassword(false); }}>Cancel</button>
      </form>
    );
  }

  return (
    <form className="admin-login" onSubmit={handleSubmit}>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoFocus
        required
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      {error && <span style={{ color: 'var(--crimson-bright)', fontSize: '0.75rem' }}>{error}</span>}
      <button type="submit" disabled={loading}>{loading ? '...' : 'Login'}</button>
      <button type="button" onClick={() => setShowLogin(false)}>Cancel</button>
    </form>
  );
}

export default AdminLogin;
